module.exports = __webpack_public_path__ + "static/46-future-of-work-the-6-key-elements-of-an-effective-digital-workplace-095ebfe6f9eb83e2d3c5669990048c3a.png";